import ArrowUpRightIcon from "@redotech/redo-icons/arrow-up-right_filled.svg";
import { cn } from "../tailwind-utils";
import { Text } from "../text";
import { TextSizeValue, TextWeightValue } from "../theme/typography";
import * as containerCss from "./redo-external-link.module.css";

export function RedoExternalLink({
  ariaLabel,
  url,
  text,
  showIcon = true,
  fontSize = "xs",
  fontWeight = "regular",
  textClassName,
  anchorClassName,
  uiSelector,
  "data-dd-action-name": actionName,
}: {
  ariaLabel?: string;
  url?: string | undefined;
  text?: string;
  fontSize?: TextSizeValue;
  showIcon?: boolean;
  fontWeight?: TextWeightValue;
  textClassName?: string;
  anchorClassName?: string;
  uiSelector?: string;
  "data-dd-action-name"?: string;
}) {
  return (
    <a
      aria-label={ariaLabel || `${text} (opens in new tab)`}
      className={cn(containerCss.container, anchorClassName)}
      data-arbiter="RedoExternalLink"
      data-dd-action-name={actionName}
      data-ui={uiSelector}
      href={url}
      rel="noreferrer"
      target="_blank"
    >
      <Text
        as="span"
        className={textClassName || containerCss.text}
        fontSize={fontSize}
        fontWeight={fontWeight}
      >
        {text}
      </Text>
      {showIcon && (
        <ArrowUpRightIcon aria-hidden className={containerCss.icon} />
      )}
    </a>
  );
}
